import React,{
  Children,
  isValidElement,
  useEffect
} from "react";
import { Close } from "@material-ui/icons";
import "./modal.css";

/**
 * Componente Footer do Modal
 */
const ModalFooter = ({ children }) => {
  // Componente de implementação - o conteúdo real é renderizado pelo Modal principal
  return <>{children}</>;
};

/**
 * Componente Content do Modal
 */
const ModalContent = ({ children }) => {
  // Componente de implementação - o conteúdo real é renderizado pelo Modal principal
  return <>{children}</>;
};

/**
 * Componente Modal para exibir conteúdo em uma janela sobreposta
 */
const ModalComponent = ({
  title,
  subtitle,
  children,
  onClose,
  isOpen = false,
  style = {},
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [isOpen]);

  if (!isOpen) return null;

  let footerContent = null;
  let mainContent = null;
  let otherChildren = children;

  if (Children.count(children) > 0) {
    const childrenArray = Children.toArray(children);

    const footerElements = childrenArray.filter(
      (child) =>
        isValidElement(child) && (child).type === ModalFooter
    );

    const contentElements = childrenArray.filter(
      (child) =>
        isValidElement(child) && (child).type === ModalContent
    );

    if (footerElements.length > 0) {
      const footerContents = footerElements.map((element) => {
        if (isValidElement(element)) {
          return (element).props.children;
        }
        return null;
      });

      footerContent = <>{footerContents}</>;
    }

    if (contentElements.length > 0) {
      const contentContents = contentElements.map((element) => {
        if (isValidElement(element)) {
          return (element).props.children;
        }
        return null;
      });

      mainContent = <>{contentContents}</>;
    }

    otherChildren = childrenArray.filter(
      (child) =>
        !(
          isValidElement(child) &&
          ((child).type === ModalFooter ||
            (child).type === ModalContent)
        )
    );
  }

  const finalContent = mainContent || otherChildren;

  return (
    <div className="overlay-modal">
      <div className="container-modal " style={style}>
        <div className="header-modal">
          <div className="title-modal-container">
            <h2 className="title-modal">{title}</h2>
            {subtitle && <p className="subtitle-modal">{subtitle}</p>}
          </div>
          <button className="close-button-modal" onClick={onClose}>
            <Close />
          </button>
        </div>
        <div className="content-modal">{finalContent}</div>
        {footerContent && <div className="footer-modal">{footerContent}</div>}
      </div>
    </div>
  );
};

export const Modal = Object.assign(ModalComponent, {
  Footer: ModalFooter,
  Content: ModalContent,
});